<template>
    <v-dialog v-model="shows" width="400" :persistent="loading">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card outlined>
            <v-card-title>프롬프트 분류 설정</v-card-title>
            <v-card-text>
                <v-chip-group column>
                    <draggable v-model="form.chatPromptGroups">
                        <template v-for="(item, index) in form.chatPromptGroups">
                            <v-chip :key="item.value" outlined label close @click:close="form.chatPromptGroups.splice(index, 1)"> {{ item.text }} </v-chip>
                        </template>
                    </draggable>
                </v-chip-group>
                <v-text-field v-model="text" v-bind="attrs_input" append-icon="mdi-plus" @click:append="add" @keydown.enter="add"> </v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn text color="red" @click="shows = false">취소하기</v-btn>
                <v-btn text color="primary" @click="save">저장하기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";
import { initChatPromptGroup, initCommonSetting } from "@/store/common/setting";

import Draggable from "vuedraggable";

export default {
    components: {
        Draggable,
    },
    props: {
        value: { type: Object, default: initCommonSetting },
    },
    data: () => ({
        form: initCommonSetting(),

        text: null,
        shows: false,
        loading: false,

        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        shows() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initCommonSetting(this.value);
        },
        add() {
            let { text } = this;
            try {
                if (this.form.chatPromptGroups.some((item) => item.text == text)) {
                    throw new Error("이미 추가된 항목입니다");
                }

                this.form.chatPromptGroups.push(initChatPromptGroup({ text }));
                this.text = null;
            } catch (error) {
                alert(error.message);
            }
        },
        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { chatPromptGroups } = this.form;
                const { setting } = await api.console.setting.put({ chatPromptGroups });
                this.shows = false;
                this.$emit("input", setting);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style></style>
